import { FormGroupItem } from "@/types/FormGroupItem"

export const getLetteredLabel = (items: FormGroupItem[]) =>
  items.map((item, index) => ({
    key: item.key,
    label: `${String.fromCharCode(index + 97)}. ${item.label}`,
  }))
